import React, { useContext, useRef, useEffect } from 'react';
import { useQuery } from 'react-query';
import { getAxiosTokenInstance } from '../../utils/axiosInstance';
import { FirebaseContext } from '../../context/FirebaseContext';


const getFieldDropDowns = (data) => async () => {
	console.log(data);
	const instance = await getAxiosTokenInstance();
	try {
		const resp = await instance.get('/college/action/getBookNames', {
			params: { ...data },
		});
		if (resp.data.statusCode === 400) {
			throw new Error(resp.data.message || 'API Error');
		} else {
			return resp?.data?.list[0].data;
		}
	} catch (error) {
		throw new Error(error?.response?.data?.message || error.message || 'API Error');
	}
};

function SearchableBookInput({ filter, keyData, stateData, setStateData, titleData }) {
	const { collegeId } = useContext(FirebaseContext);

	const [showList, setShowList] = React.useState(false);

	const useOutsideAlerter = (ref) => {
		useEffect(() => {
			function handleClickOutside(event) {
				if (ref.current && !ref.current.contains(event.target)) {
					setShowList(false);
				}
			}
			document.addEventListener('mousedown', handleClickOutside);
			return () => {
				document.removeEventListener('mousedown', handleClickOutside);
			};
		}, [ref]);
	};

	const { data: nameOfAuthorDrop = [] } = useQuery(['dataDataData', stateData[keyData]], getFieldDropDowns({ collegeId, search: stateData[keyData], filter }));

	const nameOfAuthor = useRef(null);
	useOutsideAlerter(nameOfAuthor);
	const ref = useRef(null);
	return (
		<div className='w-full my-2'>
			<div className='relative'>
				<label className='absolute -top-2 left-3 bg-neutral-100 dark:bg-neutral-800 px-1 text-xs dark:text-slate-100 font-medium z-10'>{titleData}</label>
				<input type='text' value={stateData[keyData]} onChange={(e) => setStateData({ ...stateData, [keyData]: e.target.value })} onFocus={() => setShowList(true)} className='w-full px-3 py-2 border bg-neutral-100 dark:bg-neutral-800 text-slate-800 dark:text-slate-100 border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm' />
			</div>

			{showList && stateData[keyData] && nameOfAuthorDrop.length > 0 && (
				<div ref={nameOfAuthor} className='mt-1 max-h-60 overflow-y-auto border border-gray-300 rounded-md shadow-md z-50 relative'>
					{nameOfAuthorDrop.map((item, index) => (
						<div
							key={index}
							className='px-3 py-2 text-sm dark:bg-neutral-800 text-slate-800 dark:text-slate-100 hover:bg-gray-300 dark:hover:bg-gray-300 cursor-pointer'
							onClick={() =>
								setStateData({
									...stateData,
									[keyData]: item.accessionNumber + ' | ' + item.nameOfBook,
									[keyData + 'bookId']: item.bookId,
									[keyData + 'bookStocksId']: item._id,
									[keyData + 'imageUrl']: item.image,
									[keyData + 'callNo']: item.callNo,
									[keyData + 'accessionNumber']: item.accessionNumber,
									[keyData + 'nameOfBook']: item.nameOfBook,
									[keyData + 'bookDetails']: item.bookDetails,
								})
							}>
							{item.accessionNumber + ' | ' + item.callNo + ' | ' + item.nameOfBook}
						</div>
					))}
				</div>
			)}
		</div>
	);
}

export default SearchableBookInput;
